export type SecretAliasLike = {
    alias?: string | null
}

export type SecretMacroOption = {
    value: string
    label: string
}

export const toSecretsMacroOptions = (secrets: SecretAliasLike[]): SecretMacroOption[] => {
    return (secrets ?? [])
        .map(({ alias }) => alias?.trim())
        .filter((alias): alias is string => !!alias)
        .map((alias) => ({
            value: `secrets.${alias}`,
            label: alias,
        }))
}

